const defaultState = {
  supplier_payment: 0,
  initial_fetch: false,
  notifications: [],
  total: 0,
  unreadCount: 0,
  preferences: {},
  loading: false,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_NOTIFICATION_PENDING_SUPPLIER_PAYMENT':
      return {
        ...state,
        supplier_payment: action.payload,
        initial_fetch: true,
      };
    case 'SET_NOTFICATION_COUNT':
      return {
        ...state,
        ...action.payload,
      };
    case 'SET_NOTIFICATIONS':
      return {
        ...state,
        notifications: action.payload.notifications,
        total: action.payload.total,
        loading: false,
      };
    case 'SET_NOTIFICATION_UNREAD_COUNT':
      return {
        ...state,
        unreadCount: action.payload.count,
      };
    case 'SET_NOTIFICATION_PREFERENCES':
      return {
        ...state,
        preferences: action.payload,
      };
    case 'UPDATE_NOTIFICATION':
      return {
        ...state,
        notifications: state.notifications.map(n =>
          n.id === action.payload.id ? { ...n, ...action.payload } : n
        ),
      };
    case 'DELETE_NOTIFICATION':
      return {
        ...state,
        notifications: state.notifications.filter(
          n => n.id !== action.payload.id
        ),
        total: state.total - 1,
      };
    case 'DELETE_ALL_READ_NOTIFICATIONS':
      return {
        ...state,
        notifications: state.notifications.filter(n => !n.is_read),
        total: state.notifications.filter(n => !n.is_read).length,
      };
    case 'SET_NOTIFICATIONS_LOADING':
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
};
